import { NgModule } from '@angular/core';
import { ProofOfDeliveryComponent } from 'app/_components/proof-of-delivery/proof-of-delivery.component';
import { SharedModule } from 'app/_modules/shared.module';
import { DeliveryCountPipe } from 'pipes/delivery-count.pipe';
import { OrderLineItemsPipe } from 'pipes/order-line-items.pipe';
import { PurchaseOrderService } from 'services/purchase-order.service';
import { BuyAgainComponent } from '../_components/buy-again/buy-again.component';
import { FindOrderPanelComponent } from '../_components/find-order-panel/find-order-panel.component';
import { OrderBranchComponent } from '../_components/order-branch/order-branch.component';
import { OrderConfirmationComponent } from '../_components/order-confirmation/order-confirmation.component';
import { OrderCustomerComponent } from '../_components/order-customer/order-customer.component';
import { OrderDetailsTableComponent } from '../_components/order-details-table/order-details-table.component';
import { OrderDetailsComponent } from '../_components/order-details/order-details.component';
import { OrderHistoryComponent } from '../_components/order-history/order-history.component';
import { OrderInvoiceComponent } from '../_components/order-invoice/order-invoice.component';
import { OrderItemHeaderComponent } from '../_components/order-item-header/order-item-header.component';
import { OrderItemListComponent } from '../_components/order-item-list/order-item-list.component';
import { OrderItemComponent } from '../_components/order-item/order-item.component';
import { OrderLineItemsDeliveryStatusFilterComponent } from '../_components/order-line-items-delivery-status-filter/order-line-items-delivery-status-filter.component';
import { QuotesComponent } from '../_components/quotes/quotes.component';
import { CustomerReviewFormComponent } from '../_modals/customer-review-form/customer-review-form.component';
import { DeviceListModalComponent } from '../_modals/device-list-modal/device-list-modal.component';
import { PurchaseOrderCreateModalComponent } from '../_modals/purchase-order-create-modal/purchase-order-create-modal.component';
import { DeliveredCountPipe } from '../_pipes/delivered-count.pipe';
import { OrderService } from '../_services/order.service';


@NgModule({
  declarations: [
    OrderConfirmationComponent,
    OrderDetailsComponent,
    OrderDetailsTableComponent,
    OrderLineItemsDeliveryStatusFilterComponent,
    OrderHistoryComponent,
    FindOrderPanelComponent,
    OrderBranchComponent,
    OrderCustomerComponent,
    OrderInvoiceComponent,
    BuyAgainComponent,
    OrderItemComponent,
    OrderItemHeaderComponent,
    OrderItemListComponent,
    QuotesComponent,
    ProofOfDeliveryComponent,
    // Modals
    PurchaseOrderCreateModalComponent,
    CustomerReviewFormComponent,
    DeviceListModalComponent,

    // Pipes
    DeliveredCountPipe,
    DeliveryCountPipe,
    OrderLineItemsPipe

  ],
  providers: [
    OrderService,
    PurchaseOrderService
  ],
  imports: [
    SharedModule
  ],
  exports: [
    OrderConfirmationComponent,
    OrderDetailsComponent,
    OrderDetailsTableComponent,
    OrderHistoryComponent,
    FindOrderPanelComponent,
    QuotesComponent
  ]
})
export class OrdersModule { }
